<template>
    <div class="card modern-page-card">
        <div class="card-body">
            <div class="row g-4">
                <div class="col-lg-3 text-center">
                    <img v-if="product.image && product.image !== '/Uploads/Cover.png'"
                         :src="product.image"
                         class="rounded mb-3"
                         style="width:160px;height:160px;object-fit:cover;"
                         alt="product">
                    <div v-else class="bg-label-primary rounded d-inline-flex align-items-center justify-content-center mb-3" style="width:160px;height:160px;">
                        <i class="ti ti-package" style="font-size:4rem;"></i>
                    </div>
                    <button type="button" class="btn btn-primary w-100" @click="$emit('edit')">
                        <i class="ti ti-edit me-1"></i> تعديل البيانات الأساسية
                    </button>
                </div>

                <div class="col-lg-9">
                    <div class="row g-3">
                        <InfoItem label="الصنف النمطي" :value="product.nationalFormularyName" />
                        <InfoItem label="الكود الوطني">
                            <code v-if="product.nationalCode">{{ product.nationalCode }}</code>
                            <span v-else>—</span>
                        </InfoItem>
                        <InfoItem label="التصنيف" :value="product.categoryName || product.categories" />
                        <InfoItem label="الاسم التجاري" :value="product.productName || product.name" />
                        <InfoItem label="الشركة المصنعة" :value="product.manufacturerName || product.model" />
                        <InfoItem label="بلد المنشأ" :value="product.countryName || product.material" />
                        <InfoItem label="BatchNumber" :value="product.batchNumber" />
                        <InfoItem label="عرض للعموم" :value="product.showOnPublicFormulary ? 'نعم' : 'لا'" />
                        <InfoItem label="الحالة">
                            <span class="badge" :class="statusBadgeClass">{{ statusLabel(product.status) }}</span>
                        </InfoItem>
                        <InfoItem label="تاريخ الإنشاء" :value="formatDate(product.createdOn)" />
                        <div class="col-12">
                            <div class="p-3 rounded border">
                                <div class="text-muted small mb-1">الوصف</div>
                                <div class="fw-medium">{{ product.descriptions || 'لا يوجد وصف' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const InfoItem = {
    props: ['label', 'value'],
    template: `
        <div class="col-md-6">
            <div class="p-3 rounded border h-100">
                <div class="text-muted small mb-1">{{ label }}</div>
                <div class="fw-medium">
                    <slot>{{ value || '---' }}</slot>
                </div>
            </div>
        </div>`
};

export default {
    name: 'BasicInfoTab',
    components: { InfoItem },
    props: {
        product: { type: Object, default: () => ({}) }
    },
    computed: {
        statusBadgeClass() {
            return Number(this.product.status) === 1 ? 'bg-label-success' : 'bg-label-warning';
        }
    },
    methods: {
        statusLabel(status) {
            return Number(status) === 1 ? 'نشط' : 'غير نشط';
        },
        formatDate(value) {
            if (!value) return '---';
            return new Date(value).toLocaleDateString('ar-LY');
        }
    }
};
</script>
